import * as helpers from '@mindtickle/ui-shell-core/Freshchat';

function useFreshchatHelpers() {
  return helpers;
}

export default useFreshchatHelpers;
